
import Vue from 'vue';
import { ValidationObserver } from 'vee-validate';
import Button from '@/components/Button/index.vue';
import Modal from '@/components/Modal/index.vue';
import VueQRCodeComponent from 'vue-qrcode-component';
import { getPix } from '@/services/pix/get-pix';
import { genaratePix } from '@/services/pix/post-pix';
import { updateStatusTerritoryOfficial } from '@/services/territory/update-status-territory-oficial';
import { generateLinkGix, GenerateLinkGixParams } from '@/services/gix/generate-link-gix';
import { getPixTxId } from '@/services/pix/get-pix-txid';
import { PaymentMethod } from '@/config/types';

Vue.component('qr-code', VueQRCodeComponent);

export default Vue.extend({
  components: {
    ValidationObserver,
    Button,
    Modal,
  },
  inject: ['getStepDate', 'formatNumber', 'userLogged'],
  data() {
    return {
      user: {
        name: '',
        document: '',
      },
      isDisabled: true,
      isOpenModal: false,
      loading: false,
      qrcode: '',
      txId: '',
      objectPix: {
        calendario: {
          expiracao: 3600,
        },
        devedor: {
          cpf: '',
          nome: '',
        },
        valor: {
          original: this.getStepDate.penalty.penaltyValue.toString(),
        },
        chave: process.env.VUE_APP_KEY_PIX,
        solicitacaoPagador: 'Serviço realizado.',
        infoAdicionais: [],
        // @ts-ignore
      } as any,
      cdTerritory: this.getStepDate.territory.id,
    };
  },
  methods: {
    async onCreatePaymentPix() {
      this.$emit('moreDetailsPix');
      this.loading = true;
      this.txId = `PAGAMENTOPIX${this.getStepDate.territory.id}`;
      this.objectPix.devedor.cpf = this.userLogged.stDocument;
      this.objectPix.devedor.nome = this.user.name;
      await genaratePix(this.objectPix, this.txId, this.getStepDate.territory.id);
      const response = await getPixTxId(this.getStepDate.territory.id, this.userLogged.company.stKey);
      this.qrcode = response[0].qrCode;
      this.loading = false;
      this.isOpenModal = true;
      this.getStepDate.paymentMethod = PaymentMethod.PIX;
      await updateStatusTerritoryOfficial(this.getStepDate.territory.id, 'PROVISORIO');
    },
    async getPixRequest() {
      const qrCode = await getPix(`PAGAMENTOPIX${this.getStepDate.territory.id}`);

      this.qrcode = qrCode.location;
    },
    closeModal() {
      this.isOpenModal = false;
      this.getGenerateGixLinkRequest();
      this.getStepDate.currentStep += 1;
    },
    getGenerateGixLinkRequest() {
      const params: GenerateLinkGixParams = {
        TokenKey: this.userLogged.company.stKey,
        NameTerritory: this.getStepDate.territory.name,
        CdUser: this.userLogged.idUser,
        CdTerritory: this.getStepDate.territory.id,
        CdJourneyModel: 1,
        CdJourneyGroupModel: 1,
        CdJourneyGroupTaskModel: [1, 2, 3, 4],
      };

      generateLinkGix(params).then((data) => {
        this.getStepDate.gixUrl = data;
      });
    },
  },
  created() {
    this.user.name = this.userLogged.stName;
    this.user.document = this.userLogged.stDocument;
  },
});
